import { SimplifiedUserRole } from '@platform/client/schemas';
import { GreenCircleCheckmark } from '../../../../svg/GreenCircleCheckmark';

type MatchConfirmedContentProps = {
  userAccountType: SimplifiedUserRole;
  otherPartyName: string;
};

export const MatchConfirmedContent = (props: MatchConfirmedContentProps) => {
  const { userAccountType, otherPartyName } = { ...props };
  return (
    <div className='flex flex-col md:flex-row md:items-center gap-4 md:gap-0 items-center justify-center md:justify-around h-full'>
      <div className='hidden md:flex w-1/2 items-center justify-center'>
        <GreenCircleCheckmark size={350} />
      </div>
      <div className='flex md:hidden items-center justify-center'>
        <GreenCircleCheckmark size={125} />
      </div>
      <div className='flex flex-col gap-8 md:w-1/2 text-center md:text-left'>
        <div className='text-xl font-semibold min-w-[288px] md:w-[568px]'>
          You've chosen to match!
        </div>
        <div className='text-lg min-w-[288px] md:w-[500px]'>
          {userAccountType === SimplifiedUserRole.PROFESSIONAL ?
            `We'll let ${otherPartyName} know so you can get started on this exciting project.`
          : `If they confirm the match, we will email you with next steps. In the meantime, you can see this match request as pending in your 'My Projects' page`
          }
        </div>
      </div>
    </div>
  );
};
